import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  bindAnalyticsLifecycle,
  isFirstPartyActivityAnalyticsEnabled,
  trackPageView,
} from 'services/analytics/activityTracker';

/**
 * First-party activity tracker: route changes, active time, and session heartbeats.
 * Does not capture form fields or private content — paths and durations only.
 */
const ActivityTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isFirstPartyActivityAnalyticsEnabled) return undefined;
    return bindAnalyticsLifecycle();
  }, []);

  useEffect(() => {
    if (!isFirstPartyActivityAnalyticsEnabled) return;
    void trackPageView(location.pathname, document.title);
  }, [location.pathname]);

  return null;
};

export default ActivityTracker;
